'use client'
import React, { ReactElement, useEffect, useState } from 'react'
import ShareIcon from '@/icons/font-awesome/sharp-light/share-nodes.svg'

interface ShareButtonprops {
  additionalClassNames: string
  imageUrl: string
}

export function ShareButton(props: ShareButtonprops): ReactElement | null {
  const [webShareSupported, setWebShareSupported] = useState(false)

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (navigator.share) {
      setWebShareSupported(true)
    }
  }, [])

  function handleShareClick(): void {
    if (navigator.share) {
      void navigator.share({
        url: window.location.href,
        files: undefined,
      })
    }
  }

  if (!webShareSupported) {
    return null
  }

  return (
    <div className={props.additionalClassNames}>
      <button onClick={handleShareClick}>
        <ShareIcon className="h-6 w-6 cursor-pointer fill-white" />
      </button>
    </div>
  )
}
